import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import ReactGA from 'react-ga';
import FullPageContact from './FullPageContact';
import Home from './Home';
import '../styles/application.scss';

const App = () => {
  ReactGA.initialize('UA-151021771-1');
  ReactGA.pageview(window.location.pathname + window.location.search);

  return (
    <BrowserRouter>
      <Route exact path="/" component={Home} />
      <Route path="/contact" component={FullPageContact} />
    </BrowserRouter>
  );
};

export default App;
